import { Page } from '@/components/page';
import { RegisterStepper } from '@/components/register-stepper';
import { StripeProduct } from '@/components/stripe-product';
import { useParams } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

export function Register() {
  const { priceId } = useParams();
  const fullPriceId = `price_${priceId}`;
  const { keycloak } = useKeycloak();

  console.log('priceId', priceId);

  return (
    <Page title="Register">
      <div className="rounded-md bg-yellow-50 p-4 dark:bg-yellow-900/20 mb-8">
        <div className="flex">
          <div className="flex-shrink-0">
            <InformationCircleIcon
              className="h-5 w-5 text-yellow-400"
              aria-hidden="true"
            />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
              Already have an account?
            </h3>
            <div className="mt-2 text-sm text-yellow-700 dark:text-yellow-300">
              <p>
                If you're already registered, please{' '}
                <button
                  type="button"
                  onClick={() =>
                    keycloak.login({
                      redirectUri: `${window.location.origin}/purchase-plan/${priceId}`,
                    })
                  }
                  className="font-medium underline hover:text-yellow-600 dark:hover:text-yellow-400"
                >
                  log in here
                </button>{' '}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="grid gap-8">
        <RegisterStepper />
        {priceId && <StripeProduct priceId={fullPriceId} />}
      </div>
    </Page>
  );
}
